import { DocumentNode } from 'graphql';

export default class ApiUtils {

  public static isUUID(val: string) {
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(val);
  }

  public static hasValue(obj: any) {
    return obj !== null && obj !== undefined && obj !== '';
  }

  public static getValue(obj, path: string) {
      return path.split('.').reduce((o, x) => {
          return (typeof o === 'undefined' || o === null) ? o : o[x];
      }, obj);
  }

  public static getGqlString(doc: DocumentNode) {
    return doc.loc && doc.loc.source.body;
  }

  public static nullToEmpty(obj: any) {
    return (obj === null) ? '' : obj;
  }

  public static toIntPath(obj: any, path: string, def: number = 0) {
    return ApiUtils.toInt(ApiUtils.getValue(obj, path), def);
  }

  public static toInt(obj: any, def: number = 0) {
    return obj === null || isNaN(obj) ? def : Number(obj);
  }

  public static toStringPath(obj: any, path: string, def: string = '') {
    return ApiUtils.toString(ApiUtils.getValue(obj, path), def);
  }

  public static toString(str: any, def: string = '') {
    return str === null || str === undefined ? def : String(str);
  }

  public static capitalize(str: string) {
    return ApiUtils.hasValue(str)
      ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
  }

}
